import type {
  FreshdeskInfo,
  IMPORT_STATE,
  ImportHistoryItemT,
} from '@/features/Setting/Integrations/providers/types';
import { defaultAxios } from '@/services/index';

type FreshdeskInfoDTO = {
  alias: string;
  domain: string;
  state: IMPORT_STATE;
  history: ImportHistoryItemT[];
  workspace_id: string;
};

const FreshdeskService = {
  async createFreshdeskInfo(
    workspaceAlias: string,
    domain: string,
    access_token: string,
  ): Promise<FreshdeskInfo> {
    const res = await defaultAxios.post<FreshdeskInfoDTO>(
      `/workspaces/${workspaceAlias}/freshdesk/credential`,
      { domain, access_token },
    );
    return {
      alias: res.data.alias,
      workspace_id: res.data.workspace_id,
      domain: res.data.domain,
      import_state: res.data.state,
      history: res.data.history,
    };
  },

  async getFreshdeskInfo(alias: string): Promise<FreshdeskInfo> {
    const res = await defaultAxios.get<FreshdeskInfoDTO>(
      `/workspaces/${alias}/freshdesk/`,
    );
    return {
      alias: res.data.alias,
      workspace_id: res.data.workspace_id,
      domain: res.data.domain,
      import_state: res.data.state,
      history: res.data.history,
    };
  },
  async deleteFreshdeskInfo(alias: string) {
    const res = await defaultAxios.delete(`/freshdesk/${alias}`);
    return res.data;
  },
  async importWorkspaceFeedback(alias: string, dateRange: NullableDateRangeT) {
    await defaultAxios.post(`/freshdesk/${alias}/import`, {
      start_date: dateRange.start_date,
      end_date: dateRange.end_date,
    });
  },
};

export default FreshdeskService;
